import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MindMapCanvas from './components/MindMapCanvas';
import LoginPage from './components/LoginPage';
import AdminPanel from './components/AdminPanel';
import SuperAdminLogin from './components/SuperAdminLogin';
import './App.css';

// کامپوننت کمکی برای محافظت از روت‌های کاربران عادی
const ProtectedUserRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const currentUrlSlug = urlParams.get('project');
  const storedSlug = localStorage.getItem('currentProjectSlug');

  // اگر توکن وجود دارد اما کاربر تلاش می‌کند وارد پروژه دیگری شود، لاگ‌اوت کن
  if (token && currentUrlSlug && storedSlug && currentUrlSlug !== storedSlug) {
    localStorage.clear();
    // هدایت به صفحه لاگین پروژه جدید
    return <Navigate to={`/login${location.search}`} replace />;
  }
  
  // اگر توکن وجود ندارد، هدایت به صفحه لاگین
  if (!token) {
    return <Navigate to={`/login${location.search}`} replace />;
  }

  return children;
};

// کامپوننت کمکی برای محافظت از روت‌های سوپر ادمین
const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem('superAdminAuthToken');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};


function App() {
  const handleLogout = () => {
    const slug = localStorage.getItem('currentProjectSlug');
    localStorage.clear();
    if (slug) {
        window.location.href = `/?project=${slug}`;
    } else {
        window.location.href = '/';
    }
  };

  return (
    <div className="App">
      <Routes>
        {/* روت اصلی برای نقشه (با slug پروژه) */}
        <Route 
          path="/" 
          element={
            <ProtectedUserRoute>
              <button onClick={handleLogout} className="logout-btn">خروج</button>
              <MindMapCanvas />
            </ProtectedUserRoute>
          } 
        />
        
        {/* روت صفحه لاگین کاربران */}
        <Route path="/login" element={<LoginPage />} />

        {/* روت اصلی پنل ادمین */}
        <Route 
          path="/admin" 
          element={
            <ProtectedAdminRoute>
              <AdminPanel onLogout={handleLogout} />
            </ProtectedAdminRoute>
          } 
        />
        
        {/* روت صفحه لاگین سوپر ادمین */}
        <Route path="/admin/login" element={<SuperAdminLogin />} />

        {/* اگر کاربر به ریشه سایت رفت، تصمیم بگیر کجا هدایت شود */}
        <Route 
          path="*" 
          element={
            <Navigate to={localStorage.getItem('superAdminAuthToken') ? "/admin" : "/admin/login"} />
          } 
        />
      </Routes>
    </div>
  );
}

export default App;
